import { render } from "./numericSetting.vue?vue&type=template&id=9a1c7156"
import script from "./numericSetting.vue?vue&type=script&lang=js"
export * from "./numericSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__